import { Divider, makeStyles } from '@fluentui/react-components';
import { useFormContext } from 'react-hook-form';
import { ClientOnboardingForm } from '../../../api';
import Stack from '../../layout/Stack';
import SsnInput from '../SsnInput';
import TextInput from '../TextInput';

const useStyles = makeStyles({
    // 4-column field row (First / Middle / Last / SSN), collapses to 1 column under 720px.
    // `minWidth: 0` on children overrides InputWrapper's 30% min so all four fit one row.
    nameRow: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: '16px 20px',
        width: '100%',
        '@media (max-width: 720px)': {
            gridTemplateColumns: '1fr',
        },
        '> *': {
            minWidth: 0,
        },
    },
});

const GeneralInfoCard = () => {
    const styles = useStyles();
    const { control } = useFormContext<ClientOnboardingForm>();

    return (
        <>
            <Stack flexDirection="column">
                <Divider alignContent="start" appearance="strong">
                    Main Individual
                </Divider>
                <div className={styles.nameRow}>
                    <TextInput
                        control={control}
                        name="generalSection.individualSection.firstName"
                        label="First Name"
                        rules={{ required: true }}
                    />
                    <TextInput
                        control={control}
                        name="generalSection.individualSection.middleName"
                        label="Middle Name"
                    />
                    <TextInput
                        control={control}
                        name="generalSection.individualSection.lastName"
                        label="Last Name"
                        rules={{ required: true }}
                    />
                    <SsnInput control={control} name="generalSection.individualSection.ssn" label="SSN" />
                </div>
                <Divider alignContent="start" appearance="strong">
                    Spouse Information
                </Divider>
                <div className={styles.nameRow}>
                    <TextInput
                        control={control}
                        name="generalSection.individualSection.spouseFirstName"
                        label="First Name"
                    />
                    <TextInput
                        control={control}
                        name="generalSection.individualSection.spouseMiddleName"
                        label="Middle Name"
                    />
                    <TextInput
                        control={control}
                        name="generalSection.individualSection.spouseLastName"
                        label="Last Name"
                    />
                    <SsnInput
                        control={control}
                        name="generalSection.individualSection.spouseSsn"
                        label="Spouse SSN"
                    />
                </div>
            </Stack>
        </>
    );
};

export default GeneralInfoCard;
